var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAuth)?_c('AuthLayout'):_vm._e(),(!_vm.isAuth)?_c('GuestLayout'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }